import useTranslation from 'next-translate/useTranslation'

const MPTag = () => {
  const { t } = useTranslation()

  return (
    <span className="text-12 lh-1 p-6 t-state-text is-marketplace">#{t('transaction:marketplace')}</span>
  )
}

export default MPTag
